import React, { useState } from "react";
import "./BookedEvent.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event"; // Added for date
import ScheduleIcon from "@mui/icons-material/Schedule";
import { useDispatch } from "react-redux";
import { getAttendeeAccessPass } from "../../../../Redux/Reducers/communityReducer";
import TicketCard from "./TicketCard";
import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";

const DEFAULT_IMAGE =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJUt3PE61yxQt2pJlLy5FJUP6ui46BBHmnFotsysgdKKY9pQsMc9oRkoqk2Sr--qdpbuk&usqp=CAU";

function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function formatTime(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

const BookedEventCard = ({ event, isPastEvent = false }) => {
  // console.log("BookedEventCard event:", event);
  const dispatch = useDispatch();
  const [showTicketCard, setShowTicketCard] = useState(false);
  const {
    feature_image,
    media,
    title,
    start_time,
    event_location,
    registration,
    event_category,
    organizer,
  } = event;

  let imageUrl = feature_image;
  if (!imageUrl && Array.isArray(media) && media.length > 0) {
    imageUrl = media[0].url;
  }
  if (!imageUrl) imageUrl = DEFAULT_IMAGE;

  const attendanceStatus = registration?.attendance_status || "UNKNOWN";
const statusColors = {
  PENDING: "rgba(255, 224, 178, 0.5)",   // Light Orange with 50% opacity
  ATTENDED: "rgba(200, 230, 201, 0.5)",  // Light Green with 50% opacity
  CANCELLED: "rgba(255, 205, 210, 0.5)", // Light Red with 50% opacity
  UNKNOWN: "rgba(224, 224, 224, 0.5)",   // Light Grey with 50% opacity
};


  // console.log("showTicketCard", showTicketCard)

  const handleCardClick = (ticketId) => {
    if (!isPastEvent) { // Only allow clicks for current events
      dispatch(getAttendeeAccessPass(ticketId));
      setShowTicketCard(true);
    }
  }
  const handleCloseTicketCard = () => {
    setShowTicketCard(false);
  };

  return (
    <div
      className={`ticket-card-compact ${isPastEvent ? 'past-event' : ''}`}
      onClick={() => !isPastEvent && handleCardClick(registration?.ticket_id)}
      style={{ cursor: isPastEvent ? 'default' : 'pointer' }}
    >
      
      <div
        className="ticket-header"
        style={{
          background:
            "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(0, 0, 105, 1) 0%, rgba(0, 212, 255, 1) 100%)",
        }}
      >
        <div className="event-category">{event_category || "Event"}</div>
        <div
          className="ticket-status"
          style={{ backgroundColor: statusColors[attendanceStatus] }}
        >
          {attendanceStatus.charAt(0) + attendanceStatus.slice(1).toLowerCase()}
        </div>
      </div>

      <div className="ticket-content">
        <div className="ticket-image-section">
          <div className="image-container">
            <img className="ticket-image" src={imageUrl} alt={title} />
          </div>
        </div>

        <div className="ticket-details">
          <div className="ticket-title" title={title}>
            {title}
          </div>

          <div className="detail-row">
            <div className="ticket-date-time">
              <div className="ticket-date">
                <EventIcon
                  fontSize="small"
                  style={{
                    marginRight: 8,
                    verticalAlign: "middle",
                    color: "#757575",
                  }}
                />
                {formatDate(start_time)}
              </div>
              <div className="ticket-time">
                <ScheduleIcon
                  fontSize="small"
                  style={{
                    marginRight: 8,
                    verticalAlign: "middle",
                    color: "#757575",
                  }}
                />
                {formatTime(start_time)}
              </div>
            </div>
            <div className="ticket-location" title={event_location}>
              {event.mode === "Online" ? (
                <VideoCameraFrontIcon
                  fontSize="small"
                  style={{
                    marginRight: 8,
                    verticalAlign: "middle",
                    color: "#757575",
                  }}
                />
              ) : (
                <LocationOnIcon
                  fontSize="small"
                  style={{
                    marginRight: 8,
                    verticalAlign: "middle",
                    color: "#757575",
                  }}
                />
              )}
              {event.event_location ||
                (event.mode === "Online"
                  ? "Online Event"
                  : "Location not specified")}
            </div>
          </div>

          <div className="organizer-row">
            <div className="organizer-label">Organizer:</div>
            <div className="organizer-name">{organizer?.name || "N/A"}</div>
          </div>
        </div>
      </div>

      <div className="ticket-footer">
        <div className="ticket-id">
          <span>Ticket ID:</span> {registration?.ticket_id || "N/A"}
        </div>
      </div>

      <Dialog
        open={showTicketCard}
        onClose={handleCloseTicketCard}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            background: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(16px)",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
            minHeight: "80vh",
            width: "30%",
            scrollbarWidth: "none",
            position: "relative",
          },
          elevation: 0,
        }}
        sx={{
          "& .MuiDialog-container": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(8px)",
            background: "rgba(0,0,0,0.3)",
          },
        }}
      >
        <Box
          sx={{ position: "relative", width: "100%", p: 0 }}
          onClick={(e) => e.stopPropagation()} // Prevent click bubbling
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseTicketCard}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: "flex", justifyContent: "center", p: 0 }}>
            <TicketCard event={event} onClose={handleCloseTicketCard} />
          </Box>
        </Box>
      </Dialog>
    </div>
  );
};

export default BookedEventCard;
